import * as React from 'react';

import '../../assets/style.css';
import Footer from '../../components/footer/Footer';
import CheckBox from '../../components/formElements/CheckBox';
import { makeFormControls, validateForm } from '../../components/formElements/util';
import { isEmail, isEmpty } from '../../components/formElements/validators';
import Form from '../../components/formElements/Form';
import Table from '../../components/table/Table';
import Modal from '../../components/modal/Modal';

import axios from 'axios';
import Navbar from '../../components/nav/Navbar';

import { api } from '../../environment';
import { Hotel, Star } from '@mui/icons-material';
import HotelName from '../../components/aesthetics/HotelName';
import {isBrowser, isMobile } from 'react-device-detect'

export default function ParticipationApplication(){

    

    const [pricingOptions, setPricingOptions] = React.useState([{value:"2", text:"Srednja"}, {value:"3", text:"Kasna"}, {value:"4", text:"Posebna"}, {value:'5', text:'Bez kotizacije'}, {value:'6', text:'Članovi Organizacijskog/Programskog odbora'}])

    const [departureDisabled, setDepartureDisabled] = React.useState(true)
    const [departureDates, setDepartureDates] = React.useState([])
    const [peopleNumber, setPeopleNumber] = React.useState(0)
    const [hotelVisible, setHotelVisible] = React.useState(false);
    const [paymentNeeded, setPaymentNeeded] = React.useState(true);
    const [GDPR, setGDPR] = React.useState(false);


    const setNecessary = (formControls, setFormControls, bool) => {
        let formControlsCopy = structuredClone(formControls);
        for(let key in formControlsCopy){
            if(formControlsCopy[key].validity.formNecessary!=null){
                formControlsCopy[key].value = "";
                formControlsCopy[key].validity.formNecessary = bool;
                formControlsCopy[key].validity.valid= !formControlsCopy[key].validity.necessary;
                if(!bool){
                    formControlsCopy[key].validity.warning="";
                }
            }
        }
        setFormControls(formControlsCopy);
    }

    const makePricingArray = (value) =>{
        let pricings = [{value:"2", text:"Srednja"}, {value:"3", text:"Kasna"}, {value:"4", text:"Posebna"}, {value:'5', text:'Bez kotizacije'}, {value:'6', text:'Članovi Organizacijskog/Programskog odbora'}];
        let prices = [280,380,80, 0, 0]

        if(value=="6"){
            pricings = [{value:"2", text:"Srednja"}, {value:"3", text:"Kasna"}, {value:"4", text:"Posebna"}, {value:'5', text:'Bez kotizacije'}]
            prices = [380, 480, 180, 0]
        }

        return pricings.map((pricing, index)=>{
            return {value: pricing.value, text: pricing.text + ' - ' + prices[index].toString() + " €" }
        })

    }

    const makeDepartureDates = (value)=>{
        const departureDates = ['5.11.2026', '6.11.2026', '7.11.2026'];

        return departureDates.slice(Number(value)-4, departureDates.length).map((date, index)=>{
            return {value:date[0], text:date}
        })
    }

    const paymentProviderFormData=[
        {name:'name', type:'text', label:'naziv platitelja', necessary:true, formNecessary:paymentNeeded, validators:[isEmpty], layoutStyle:{flex:'1 1 45%'}},
        {name:'address', type:'text', label:'adresa platitelja', necessary:true, formNecessary:paymentNeeded, validators:[isEmpty], layoutStyle:{flex:'1 1 45%'}},
        {name:'oib', type:'text', label:'oib platitelja', necessary:true, formNecessary:paymentNeeded, validators:[isEmpty], layoutStyle:{flex:'1 1 45%'}},
        {name:'email', type:'text', label:'e-mail adresa platitelja', necessary:true, formNecessary:paymentNeeded, validators:[isEmpty, isEmail], layoutStyle:{flex:'1 1 45%'}},
        {name:'payment_way', type:'select', label:'način plaćanja', necessary:true, formNecessary:paymentNeeded, validators:[isEmpty],
            options:[
                {value:'1', text:'Bankovna transakcija'},
                {value:'2', text:'Kreditna kartica'}
            ], layoutStyle:{flex:'1 1 100%'}}
    ]

    const [paymentProviderFormControls, setPaymentProviderFormControls] = React.useState(makeFormControls(paymentProviderFormData));

    const participantFormData=[
        {name:'first_name', type:'text', label:'ime', necessary:true, validators:[isEmpty], layoutStyle:{flex:'1 1 45%'}},
        {name:'last_name', type:'text', label:'prezime', necessary:true, validators:[isEmpty], layoutStyle:{flex:'1 1 45%'}},
        {name:'oib', type:'text', label:'oib', necessary:false, validators:[isEmpty], layoutStyle:{flex:'1 1 45%'}},
        {name:'address', type:'text', label:'adresa', necessary:true, validators:[isEmpty], layoutStyle:{flex:'1 1 45%'}},
        {name:'state', type:'text', label:'država', necessary:true, validators:[isEmpty], layoutStyle:{flex:'1 1 45%'}},
        {name:'city', type:'text', label:'grad', necessary:true, validators:[isEmpty], layoutStyle:{flex:'1 1 45%'}},
        {name:'phone', type:'text', label:'telefon', necessary:false, validators:[isEmpty], layoutStyle:{flex:'1 1 45%'}},
        {name:'mobile', type:'text', label:'mobitel', necessary:false, validators:[isEmpty], layoutStyle:{flex:'1 1 45%'}},
        {name:'e_mail', type:'text', label:'osobna e-mail adresa', necessary:true, validators:[isEmpty, isEmail], layoutStyle:{flex:'1 1 45%'}},
        {name:'hpk_number', type:'select', label:'potrebna prijava sudjelovanja HPK - Hrvatskoj psihološkoj komori', necessary:true, 
            options: [{value:"1", text: "Da"},
                    {value:"2", text: "Ne"}
            ],
            validators: [isEmpty], layoutStyle:{flex:'1 1 45%'}},
        {name:'hpd_membership', type:'select', label:'Stanje članstva HPD', defaultValue:"", necessary:true, 
            options:[{value:"1", text:"Redovno"}, 
                {value:"2", text:"Pridruženo"}, 
                {value:"3", text:"Studentsko"},
                {value:"4", text:"Umirovljeničko"},
                {value:"5", text:"Počasno"},
                {value:"6", text:"Nisam član/članica HPD"}], validators:[isEmpty], layoutStyle:{flex:'1 1 45%'}, 
            callback:(e)=>{
                setPricingOptions(makePricingArray(e.target.value))
                setParticipantFormControls((prevState)=>{
                    prevState['payment_type'] = {value:"", validity:{necessary:true, valid:false}}

                    return {...prevState}
                });
                
                
 
            }},
        {name:'payment_type', type:'select', label:'Vrsta kotizacije', defaultValue:"", necessary:true,
            options:pricingOptions, callback:(e)=>{
                if(e.target.value=="6" || e.target.value=="5") {
                    setPaymentNeeded(false);
                    setNecessary(paymentProviderFormControls, setPaymentProviderFormControls, false);
                } else {
                    setPaymentNeeded(true)
                    setNecessary(paymentProviderFormControls, setPaymentProviderFormControls, true);
                }}, layoutStyle:{flex:'1 1 45%'}, validators:[isEmpty]}
    ]

    const hotelFormData=[
        {name:'hotel', type:'select', label:'hotel', necessary:true, formNecessary:false, validators:[isEmpty],
            options:[
                {value:'1', text:'Hotel Olympia (4 zvjezdice)'},
		{value:'2', text:'Hotel Olympia Sky (4+ zvjezdice)'},
		{value:'3', text:'Hotel Imperial'},
            ], layoutStyle:{flex:'1 1 100%'}},
        {name:'person_count', type:'select', label:'broj osoba u sobi', necessary:true, formNecessary:false, validators:[isEmpty],
            options:[
                {value:'1', text:'1'},
                {value:'2', text:'2'}
            ], layoutStyle:{flex:'1 1 100%'},
        callback:(e)=>{
            setPeopleNumber(Number(e.target.value))
        }}, 
        {name: 'date_arrival', type:'select', label:'datum dolaska', necessary:true, formNecessary:false, validators:[isEmpty],
            options:[
                {value:'4', text:'4.11.2026'},
                {value:'5', text:'5.11.2026'},
                {value:'6', text:'6.11.2026'},
            ], layoutStyle:{flex:'1 1 45%'},
            callback: (e)=>{
                setDepartureDates(makeDepartureDates(e.target.value));
                setDepartureDisabled(false);
            }
        },
        {name: 'date_departure', type:'select', label:'datum odlaska', necessary:true, formNecessary:false, validators:[isEmpty],
            options:departureDates, layoutStyle:{flex:'1 1 45%'},
            disabled:departureDisabled,
        },
        {name:'name_roommate', type:'text', label:'ime i prezime druge osobe u sobi', necessary:peopleNumber==2, validators:[isEmpty], formNecessary:false, layoutStyle:{flex:'1 2 45%'}, hidden:peopleNumber<2},
        {name:'note', type:'textarea', label:'napomena', necessary:false, formNecessary:false, layoutStyle:{flex:'1 1 100%'}}
    ]

    const [participantFormControls, setParticipantFormControls] = React.useState(makeFormControls(participantFormData));
    const [hotelFormControls, setHotelFormControls] = React.useState(makeFormControls(hotelFormData));
    

    const pricingTableHeader = [
        {name:"order", label:"#"},
        {name:"description", label:"opis"},
        {name:"price", label:"cijena"},
    ]


    const makePaymentDescription = (isMember, paymentType) => {
            if(paymentType=="6"){
                return "Kotizacija za članove Organizacijskog/Programskog odbora"
            }
            if(paymentType=="5"){
                return "Bez kotizacije"
            }
            const pricings = ['Rana', 'Srednja', 'Kasna', 'Posebna'];
            return isMember!=""&&paymentType!=""&&paymentType!="5"?`${pricings[Number(paymentType)-1]} kotizacija ${isMember!="6"?"za članove HPD-a":""}`:"";
        }

        const makeHotelPriceDescription = () => {
            let number_nights = Number(hotelFormControls['date_departure'].value)-Number(hotelFormControls['date_arrival'].value)
            let show = hotelFormControls['person_count'].value != "" && number_nights != 0;
            
            if(participantFormControls['payment_type'].value=="6"){
                return show?"Cijena boravka za članove Organizacijskog/Programskog odbora":""
            }
           
            return show?`Cijena boravka (${hotelFormControls['person_count'].value=="1"?"jedna osoba":"dvije osobe"}) za ${number_nights==1?"jedno noćenje":number_nights==2?"dva noćenja":'tri noćenja'} na bazi ${hotelFormControls['hotel'].value=="1"?"pansiona s doručkom i ručkom.":hotelFormControls['hotel'].value=="2"?"pansiona s doručkom i ručkom":"noćenja s doručkom."}`:""
        }
    
    const makePaymentPrice = (isMember, paymentType)=>{
        let prices = [180,280,380,80, 0, 0]
        
        if(isMember=="6"){
            prices = [280,380, 480, 180, 0, 0]
        }

        return isMember!=""&&paymentType!=""&&paymentType!="5"?prices[Number(paymentType)-1]:0
    }

    const computeHotelpricing = (peopleNumber, hotel, table=false) => {
        const prices = {
            "" : [],
            "1": [130, 175, 90],
            "2": [180, 225, 105]
        }
        if(table){
            return prices[peopleNumber][Number(hotel)-1]
        }
        if(peopleNumber!=""&&hotel!=""){
            if(participantFormControls['payment_type'].value=="6"){
                return ""
            }
            return prices[peopleNumber][Number(hotel)-1]
        } else return ""
        
    }

    const sumPricing = () => {
        return (Number(hotelFormControls['date_departure'].value)-Number(hotelFormControls['date_arrival'].value))*computeHotelpricing(hotelFormControls['person_count'].value, hotelFormControls['hotel'].value)+makePaymentPrice(participantFormControls['hpd_membership'].value, participantFormControls['payment_type'].value);
    }

    const pricingTableRows = [
        {order: "1.", description:makePaymentDescription(participantFormControls['hpd_membership'].value,participantFormControls['payment_type'].value), 
        price:makePaymentPrice(participantFormControls['hpd_membership'].value,participantFormControls['payment_type'].value).toString()+'.00 €'},
        {order: "2.", description:makeHotelPriceDescription(), price:`${computeHotelpricing(hotelFormControls['person_count'].value, hotelFormControls['hotel'].value)*(hotelFormControls['date_departure'].value!=""?Number(hotelFormControls['date_departure'].value)-Number(hotelFormControls['date_arrival'].value):0)}.00 €`},
        {order: "", description:"", price:`total: ${sumPricing().toString()}.00 €`}
    ]

    const paymentPricingHeader = [
        {name:"payment_type", label:"", width:"25%"},
        {name:"hpd_members", label:"Članovi HPD-a*", width:"45%"},
        {name:"rest", label:"Ostali", width:"20%"},
    ]

    

    const paymentPricingBody = [
        {payment_type:"Rana (do 31.07.2026.)", hpd_members:"180.00 €", rest:"280.00 €"},
        {payment_type:"Srednja (od 1.8.2026. do 18.10.2026.)", hpd_members:"280.00 €", rest:"380.00 €"},
        {payment_type:"Kasna (od 19.10.2026. do 3.11.2026)", hpd_members:"380.00 €", rest:"480.00 €"},
        {payment_type:"Posebna**", hpd_members:"80.00 €", rest:"180.00 €"}
    ]

    const hotelPricingHeader = [
        {name:"hotelName", label:"Hotel", width:"40%"},
        {name:"priceSingle", label:"Jedna osoba*", width:"20%"},
        {name:"priceDouble", label:"Dvije osobe*", width:"20%"},
        {name:"service", label:"Uključeno", width:"20%"},
    ]

    const hotelPricingBody=[
        {hotelName:<HotelName name='Hotel Olympia'  stars={4}/>, priceSingle:computeHotelpricing('1','1', true)+ " €", priceDouble:computeHotelpricing('2','1', true)+ " €", service:'Polupansion (doručak i ručak)'},
	{hotelName:<HotelName name='Hotel Olympia Sky'  stars={4}/>, priceSingle:computeHotelpricing('1','2', true)+ " €", priceDouble:computeHotelpricing('2','2', true)+ " €", service:'Polupansion (doručak i ručak)'},
	{hotelName:<HotelName name='Hotel Imperial'  stars={3}/>, priceSingle:computeHotelpricing('1','3', true)+ " €", priceDouble:computeHotelpricing('2','3', true)+ " €", service:'Noćenje s doručkom'},
    ]

    const [modalHidden, setModalHidden] = React.useState(true);

    const sendFormData = () =>{
        let formData = {'participant':participantFormControls,
                        'hotel': (hotelVisible)?hotelFormControls:null,
                        'payment':(paymentNeeded)?paymentProviderFormControls:null}
        axios.post(api+'/submit_participation', formData).then(
            (response) => {
                
            }
        ).catch((err)=>{console.log(err)});
    }

    const submitForm = () =>{

        let participantFormValid = validateForm(participantFormData, participantFormControls, setParticipantFormControls);
        let hotelFormValid = hotelVisible?validateForm(hotelFormData, hotelFormControls, setHotelFormControls):true;
        let paymentProviderFormValid = validateForm(paymentProviderFormData, paymentProviderFormControls, setPaymentProviderFormControls);
        if (participantFormValid && hotelFormValid && paymentProviderFormValid){
            sendFormData();
            setModalHidden(false);
        } else {
        }

    }

    return (
        <>
        <Navbar/>
        <div className='flex-row' style={{justifyContent:"space-around"}}>
        <div className="flex-column background-opaque" style={{paddingTop:"30vh", paddingBottom:"2rem", gap:"4rem", width:"100%", justifyContent:"center"}}>
            <div style={{width:isMobile?"96vw":"50vw", margin:"auto"}}>
            <div><h1 style={{fontWeight:"400", fontSize:isMobile?"2rem":"3.5rem", textAlign:"center"}}>Prijava sudjelovanja</h1></div>
                <div>
                    <h2 className="form-subtitle">Podatci o sudioniku</h2>
                    <div className={isMobile?"flex-column":"flex-row"} style={{flexWrap:"wrap", gap:"1.2rem"}}>
                        <Form formData={participantFormData} formControls={participantFormControls} setFormControls={setParticipantFormControls}/>
                    </div>
                </div>
                <div>
                <div style={{padding:"2.3rem", paddingBottom:"3rem"}}>
        <CheckBox fontSize="1.5rem" fontWeight='700' label="Želim prijaviti hotelski smještaj" onChange={()=>{
            setHotelVisible(!hotelVisible)
            setNecessary(hotelFormControls, setHotelFormControls, !hotelVisible)
        }}/>
        </div>
        <div hidden={!hotelVisible}>
        <Form formData={hotelFormData} formControls={hotelFormControls} setFormControls={setHotelFormControls}/>
        <div>
            <h2>Cijene noćenja</h2>
        <Table header={hotelPricingHeader} dataSource={hotelPricingBody}/>
        </div>
        </div>
                </div>
                <div hidden={!paymentNeeded}>
                    <h2 className="form-subtitle">Podatci o platitelju</h2>
                    <div className={isMobile?"flex-column":"flex-row"} style={{flexWrap:"wrap", gap:"1.2rem"}}>
            <Form formData={paymentProviderFormData} formControls={paymentProviderFormControls} setFormControls={setPaymentProviderFormControls}/>
        </div>
                </div>
                <div className="tool-tray"><button onClick={submitForm} className='pillbox'>Prijava</button></div>
                <div className="table-wrap">
                    <h2 className="form-subtitle">Izračun cijene sudjelovanja</h2>
                    <Table header={pricingTableHeader} dataSource={pricingTableRows}/>
                </div>
                <div className="table-wrap">
                    <h2 className='form-subtitle' style={{paddingTop:"1rem"}}>Iznosi kotizacije (s uključenim PDV-om)</h2>
                    <Table header={paymentPricingHeader} dataSource={paymentPricingBody}/>
                    <div style={{color:"rgb(34, 61, 105)", textAlign:"center", paddingTop:"1rem"}}>
                        <p>* odnosi se na članove Hrvatskog psihološkog društva s podmirenom članarinom za 2026.godinu</p>
                        <p>** umirovljeni psiholozi, nezaposleni psiholozi, studenti psihologije preddiplomskog i diplomskog studija i psiholozi - vježbenici</p>
                        <p style={{color:"red",paddingTop:"1rem"}}>Za bilo kakva pitanja oko kotizacija, slanja predračuna i/ili računa (e-računa), molimo Vas kontaktirajte nas putem e-maila goran.grbic@vivid-original.com ili na mobitel +385(0)98 170 6028</p>
                        </div>
                </div>
                
            </div>
            <Modal hidden={modalHidden} title="Vaša prijava je zaprimljena" content={<div><p>Na vašu e-mail adresu primit ćete potvrdu o zaprimanju vaše prijave s primjerkom vašeg odgovora. Predračun za plaćanje kotizacije dobit ćete od Kongresne agencije u roku od 48 sati.<br/><br/>
            Za sva dodatna pitanja budite slobodni obratiti se Kongresnoj agenciji Vivid Original, <br/> kontakt osoba Goran Grbić (goran.grbic@vivid-original.com).</p>
            <br/><p style={{fontWeight:"bold"}}>Klikom na "U redu" dajete PRIVOLU Hrvatskom psihološkom društvu – 10020 Zagreb, Baburičina 215, OIB: 24373843542 (voditelju obrade osobnih podataka) da vaše osobne podatke koristi za potrebe sudjelovanja na 33.godišnjoj konferenciji psihologa.</p></div>} 
            buttons={[<button className="modal-button" onClick={()=>{
                setModalHidden(true);
                window.location.reload();
            }}>U redu</button>]}/>
                
        </div>
        </div>
        <Footer/>
        </>
    )
}
